import dayjs from 'dayjs';
import { NavigationGuard } from 'vue-router';

const VALID_ON_FILTER_GUARD: NavigationGuard = async (to, from, next) => {
   if (to.name === from.name) return next();

   if (to.query.valid_on) return next();

   return next({ ...to, query: { ...to.query, valid_on: dayjs().format('YYYY-MM-DD') } });
};

export default VALID_ON_FILTER_GUARD;
